import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { Button, Checkbox, Form, Input, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./style.scss";
import {
  isRequired,
  isPhoneNumber,
  isEmail,
  validatePasswordLength,
  validatePassWordConfirm,
} from "../fields/validator";
import { ROUTER_PATH, SIGN_UP_VALUES } from "../../common/constant";
import { resetStatus, selectAuth } from "../../redux/reducers/slice/auth";
import ConfirmSignUpModal from "../modal/confirmSignUpModal";
import { useTranslation } from "react-i18next";
import { localizeRouteKey } from "../../shared/helpers";
import { setTitlePage } from "../../utils/helper";
import { NAME_AUTH } from "../wishButton/authModal";
import Turnstile, { useTurnstile } from "react-turnstile";
import { CLOUDFLARE_SITE_KEY } from "../../utils/constant";

const AuthSignUp = (props: any) => {
  const turnstile = useTurnstile();
  const { type, setNameAuthModal } = props;
  const auth = useSelector(selectAuth);
  const dispatch = useDispatch();
  const signUpValuesInit = JSON.parse(
    `${sessionStorage.getItem(SIGN_UP_VALUES)}`
  );
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();
  const [captchaToken, setCaptchaToken] = useState<string | null>("");

  useEffect(() => {
    if (type !== "MODAL") {
      setTitlePage(t("title_page_sign_up"));
    }
    dispatch(resetStatus());
  }, []);

  useEffect(() => {
    if (auth.status === 200) {
      if (type === "MODAL") {
        setNameAuthModal(NAME_AUTH.confirmOTP);
      } else {
        props.history.push(localizeRouteKey(ROUTER_PATH.CONFIRM_OTP));
      }
    }
  }, [auth]);

  const handleSubmit = async (values: any) => {
    const query = {
      last_name: values.lastName,
      first_name: values.firstName,
      phone_number_signup: values.phoneNumber,
      email_signup: values.email,
      password_signup: values.password,
      token: captchaToken
    };

    sessionStorage.setItem(SIGN_UP_VALUES, JSON.stringify(query));

    setVisible(true);
  };


  const handleOnVerify = (token: string) => {
    setCaptchaToken(token);
  }

  const onHandleErrorTurnstile = (error: any) => {
    setCaptchaToken(null);
    turnstile?.reset();
  }
  return (
    <div>
      <div className="kd-sign-up-form-content center">
        <span className="kd-name-component">{t("title_screen_sign_up")}</span>
      </div>

      <Form
        className="kd-sign-up-form-content center content-auth-wrapper"
        size="large"
        name="signUpForm"
        onFinish={(values) => handleSubmit(values)}
        initialValues={{
          lastName: signUpValuesInit !== null ? signUpValuesInit.last_name : "",
          firstName:
            signUpValuesInit !== null ? signUpValuesInit.first_name : "",
          phoneNumber:
            signUpValuesInit !== null
              ? signUpValuesInit.phone_number_signup
              : "",
          email: signUpValuesInit !== null ? signUpValuesInit.email_signup : "",
          password:
            signUpValuesInit !== null ? signUpValuesInit.password_signup : "",
          passwordConfirm:
            signUpValuesInit !== null ? signUpValuesInit.password_signup : "",
        }}>
        <div className="kd-sign-up-form-item-row">
          <Form.Item
            className="kd-sign-up-form-item"
            name="lastName"
            rules={[isRequired]}>
            <Input
              className="input"
              // placeholder={t("field_last_name")}
              addonBefore={t("field_last_name")}
            />
          </Form.Item>
          <Form.Item
            className="kd-sign-up-form-item"
            name="firstName"
            rules={[isRequired]}>
            <Input
              className="input"
              // placeholder={t("field_first_name")}
              addonBefore={t("field_first_name")}
            />
          </Form.Item>
        </div>
        <Form.Item
          className="kd-sign-up-form-item"
          name="phoneNumber"
          rules={[isRequired, isPhoneNumber]}>
          <Input
            className="input"
            // placeholder={t("field_phone_number")}
            addonBefore={t("field_phone_number")}
          />
        </Form.Item>

        <Form.Item
          className="kd-sign-up-form-item"
          name="email"
          rules={[isRequired, isEmail]}>
          <Input
            className="input"
            // placeholder={t("field_email")}
            addonBefore={t("field_email")}
          />
        </Form.Item>

        <Form.Item
          className="kd-sign-up-form-item"
          name="password"
          rules={[isRequired, validatePasswordLength]}>
          <Input.Password
            className="input"
            // placeholder={t("field_password")}
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
            addonBefore={t("field_password")}
          />
        </Form.Item>
        <Form.Item
          className="kd-sign-up-form-item"
          name="passwordConfirm"
          rules={[validatePassWordConfirm]}>
          <Input.Password
            className="input"
            // placeholder={t("field_password_re")}
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
            addonBefore={t("field_password_re")}
          />
        </Form.Item>

        <Form.Item
          name="agreement"
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) =>
                value
                  ? Promise.resolve()
                  : Promise.reject(new Error(t("policy_agreement_require"))),
            },
          ]}>
          <Checkbox>
            <span className="message" style={{ color: "black" }}>
              {t("policy_agreement_description")}
              <Link to={localizeRouteKey(ROUTER_PATH.POLICY_AND_GENERAL_TERMS)}>
                {t("policy_agreement_link")}
              </Link>
              {t("policy_agreement_suffix")}
            </span>
          </Checkbox>
        </Form.Item>
        <Form.Item>
          <Turnstile
            sitekey={`${CLOUDFLARE_SITE_KEY}`}
            onSuccess={handleOnVerify}
            onError={onHandleErrorTurnstile}
            onExpire={onHandleErrorTurnstile}
            onTimeout={onHandleErrorTurnstile}
            theme="light"
            refreshExpired="auto"
          />
        </Form.Item>

        <Form.Item noStyle>
          <span className="message">{auth.message}</span>
          {auth.loading ? (
            <Spin size="large" />
          ) : (
            <Button
                className="kd-sign-up-form-button kd-btn-primary-2"
                type="primary"
                loading={!captchaToken}
                disabled={!captchaToken}
                htmlType="submit">
              {t("btn_sign_up")}
            </Button>
          )}
        </Form.Item>
      </Form>

      {signUpValuesInit !== null && (
        <ConfirmSignUpModal
          visible={visible}
          setVisible={setVisible}
          onFailed={onHandleErrorTurnstile}
          signUpValuesInit={JSON.parse(
            `${sessionStorage.getItem(SIGN_UP_VALUES)}`
          )}
        />
      )}
    </div>
  );
};

export default AuthSignUp;
